import type { Split } from '~/types/utils';

import type { DynamicRoutes, DynamicSegments, ReplaceDynamicSegments } from './router.types';

export const routes = {
  login: '/login',
  activate: '/activate/:activationKey',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  register: '/register',
  registerAccountInformation: '/register/1',
  registerBusinessInformation: '/register/2',
  registerCompany: '/register/company',
  registerSuccess: '/register/success',

  dashboard: '/dashboard',

  quotations: '/quotations',
  createQuotation: '/quotations/create/:quotationId',
  editQuotation: '/quotations/:quotationId/edit',

  invoices: '/invoices',
  showInvoice: '/invoices/:invoiceId',
  createInvoice: '/invoices/create/:invoiceId',
  editInvoice: '/invoices/:invoiceId/edit',

  creditNotes: '/credit-notes',
  createCreditNote: '/credit-notes/create',

  invoiceTemplates: '/invoice-templates',
  showInvoiceTemplate: '/invoice-templates/:invoiceTemplateId',
  createInvoiceTemplate: '/invoice-templates/create',
  editInvoiceTemplate: '/invoice-templates/:invoiceTemplateId/edit',

  products: '/products',
  createProduct: '/products/create',
  editProduct: '/products/:productId/edit',

  clients: '/clients',
  showClient: '/clients/:clientId',
  createClient: '/clients/create',
  createClientOrganisationStep: '/clients/create/organisation',
  createClientContactStep: '/clients/create/contact',
  createClientPrivateStep: '/clients/create/private',
  editClient: '/clients/:clientId/edit',
  createContact: '/clients/:clientId/contacts/create',
  editContact: '/clients/:clientId/contacts/:contactId',

  network: '/network',

  forum: '/forum',
  forumTimeline: '/forum/timeline',
  forumSelfPosts: '/forum/self',
  forumSavedPosts: '/forum/saved',
  forumPost: '/forum/:postId',
  forumGuidelines: '/forum/guidelines',

  jobPosts: '/job-posts',
  bookmarkedJobPosts: '/job-posts/bookmarked',
  ownJobPosts: '/job-posts/own',
  createJobPost: '/job-posts/create',
  showJobPost: '/job-posts/:jobPostId',
  editJobPost: '/job-posts/:jobPostId/edit',

  invitations: '/invitations',

  documents: '/documents',

  pricing: '/pricing',

  settingsProfile: '/settings/profile',
  settingsEmail: '/settings/email',
  settingsInvoice: '/settings/invoice',
  settingsCompany: '/settings/company',
  settingsIntegrations: '/settings/integrations',

  quotationForClient: '/quotations/:approvalKey/client',

  oauthBillit: '/oauth2/callback/billit',

  uiToolkit: '/developer/UI-toolkit',
  designSystem: '/design-system',
} as const satisfies Record<string, `/${string}`>;

/** Replace dynamic parts of a route by concrete values. */
export const r = <T extends DynamicRoutes[keyof DynamicRoutes], const U extends Record<DynamicSegments<T>, string | number>>(
  route: T,
  replacements: U,
) =>
  (route.split('/') as Split<T, '/'>)
    .map((segment) => (segment.startsWith(':') ? replacements[segment.slice(1) as keyof U] : segment))
    .join('/') as ReplaceDynamicSegments<T, U>;
